import V1 from './v1';
import V2 from './v2';
import V3 from './v3';

export default (props) => {
  const consentVersion =
    props.application?.consent?.consentVersion || props.application?.consent?.termsVersion;

  if (consentVersion === 'v1') {
    return <V1 {...props} />;
  }

  if (consentVersion === 'v2') {
    return <V2 {...props} />;
  }

  return <V3 {...props} />;
};
